import {
  Box, DashboardModule, Image, ListItem, Text,
} from '@domain-group/suit-theme'

import type {
  AgencyModel, BrandModel, ProviderModel,
} from '@models/types'

import type { UseInvoicePayload } from '@hooks/useInvoice'

interface DebtorDetailsProps {
  invoicePayload: UseInvoicePayload,
}

type DebtorType = 'Agency' | 'Brand' | 'Provider' | undefined
type Debtor = AgencyModel | BrandModel | ProviderModel

const findDebtorLogo = (debtorType: DebtorType, debtor: Debtor) => {
  if (debtorType === 'Agency' && (debtor as AgencyModel)?.default_image){
    return (debtor as AgencyModel)?.default_image
  }

  if (debtorType === 'Provider' && (debtor as ProviderModel)?.logo?.thumb){
    return (debtor as ProviderModel)?.logo?.thumb
  }

  if (debtorType === 'Brand' && (debtor as BrandModel)?.logo?.small){
    return (debtor as BrandModel)?.logo?.small
  }

  return ''
}

const DebtorDetails = (props: DebtorDetailsProps) => {
  const {
    invoicePayload: {
      callbacks: { manageInvoiceDebtor },
      debtor,
      invoice,
    },
  } = props

  const {
    address, approved, debtor_name, debtor_type, purchase_order, void: isVoid,
  } = invoice

  const {
    title,
  } = debtor || {}

  return (
    <DashboardModule title="Debtor">
      <ListItem
        boxProps={{
          alignItems: 'center',
          padding: 'large',
          as: 'a',
        }}
        disableHover={approved}
        onClick={approved || isVoid ? undefined : () => manageInvoiceDebtor()}
        showAngleIcon={!approved && !isVoid}
      >
        <Image
          backgroundSize="contain"
          borderRadius={5}
          boxProps={{ border: '1px solid', borderColor: 'lineColor' }}
          height={50}
          // @ts-expect-error TS2345
          url={findDebtorLogo(debtor_type, debtor)}
          width={84}
        />

        <Box justifyContent="space-between">
          <Box flexDirection="column" paddingLeft="large">
            <Text fontSize="small" variant="ellipsis">{title}</Text>

            <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">
              {address}
            </Text>
          </Box>

          <Box alignItems="flex-end" display={['none', 'flex']} flexDirection="column" justifyContent="center">
            <Text fontSize="xsmall" variant="ellipsis">
              {debtor_name}
            </Text>

            {purchase_order && (
              <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">
                Purchase Order #&nbsp;{purchase_order}
              </Text>
            )}
          </Box>
        </Box>
      </ListItem>
    </DashboardModule>
  )
}

export default DebtorDetails
